import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const ProgramsSection = () => {
  const { translations, language } = useLanguage();
  const programs = translations?.programs || [];
  
  const learnMoreText = language === 'fr' ? 'En savoir plus' : 'Learn More';

  if (!programs.length) return null;

  return (
    <section id="programs" className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1D1D1D]">
            {translations?.programsTitle}
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            {translations?.programsSubtitle}
          </p>
        </div>

        {/* Programs Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {programs.map((program) => (
            <div
              key={program.id}
              className="bg-white overflow-hidden shadow-lg group hover:shadow-xl transition-shadow duration-300"
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={program.image}
                  alt={program.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-[#1D1D1D] mb-3">
                  {program.title}
                </h3>
                <p className="text-gray-600 mb-4">
                  {program.description}
                </p>
                <a
                  href={`#program-${program.id}`}
                  className="inline-flex items-center gap-2 text-[#CD0000] font-bold hover:gap-3 transition-all"
                >
                  {learnMoreText} <ArrowRight className="w-4 h-4" />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProgramsSection;
